import React from "react";
import PageMeta from "../components/PageMeta";

export default function Privacy() {
    return (
        <div className="bg-[#09090b] text-zinc-100">
            <PageMeta
                title="Politique de confidentialité — Sponsormania.fr"
                description="Politique de confidentialité Sponsormania.fr : données collectées, finalités, base légale, durée de conservation, droits RGPD."
            />
            <article className="max-w-3xl mx-auto px-6 py-16 space-y-8">
                <div>
                    <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">Vie privée</div>
                    <h1 className="font-display text-5xl uppercase tracking-tight">Politique de confidentialité</h1>
                </div>

                <Section title="Responsable de traitement">
                    <p>
                        Sponsormania.fr est responsable du traitement de vos données personnelles
                        collectées via le site.
                    </p>
                </Section>

                <Section title="Données collectées">
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Nom, prénom, email, mot de passe (chiffré)</li>
                        <li>Numéro de téléphone (contact)</li>
                        <li>Pour les clubs : nom et téléphone du président, informations sportives et adresse</li>
                        <li>Pour les sponsors : numéro SIREN, raison sociale, logos téléversés</li>
                        <li>Historique des sponsorings et des points de fidélité</li>
                        <li>Données techniques (IP, navigateur, cookies de session)</li>
                    </ul>
                </Section>

                <Section title="Finalités">
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Gestion des comptes et de l'authentification</li>
                        <li>Exécution des sponsorings et du programme fidélité</li>
                        <li>Communication transactionnelle (confirmations, expéditions)</li>
                        <li>Modération et prévention des fraudes</li>
                    </ul>
                </Section>

                <Section title="Base légale">
                    <p>
                        Les traitements sont fondés sur l'exécution du contrat (CGU), le consentement (ex. cookies
                        non essentiels), et l'intérêt légitime (sécurité, lutte contre la fraude).
                    </p>
                </Section>

                <Section title="Durée de conservation">
                    <p>
                        Les données de compte sont conservées pendant toute la durée de la relation commerciale et
                        pendant 3 ans après le dernier contact, sauf obligations légales plus longues
                        (ex. 10 ans pour les factures).
                    </p>
                </Section>

                <Section title="Destinataires">
                    <p>
                        Vos données sont traitées en interne par Sponsormania.fr. Elles peuvent être transmises à nos
                        sous-traitants (hébergement, envoi d'email, production des maillots) dans le cadre strict
                        de l'exécution du service.
                    </p>
                </Section>

                <Section title="Vos droits">
                    <p>
                        Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation
                        et de portabilité sur vos données. Pour exercer ces droits, écrivez à{" "}
                        <a className="text-orange-500" href="mailto:privacy@sponsormania.fr">privacy@sponsormania.fr</a>.
                        Vous pouvez également saisir la CNIL.
                    </p>
                </Section>

                <Section title="Cookies">
                    <p>
                        Le site utilise uniquement des cookies strictement nécessaires à l'authentification et au
                        bon fonctionnement. Aucun cookie tiers publicitaire n'est déposé.
                    </p>
                </Section>

                <p className="text-xs text-zinc-500 pt-6 border-t border-zinc-800">
                    Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}.
                </p>
            </article>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-display text-2xl uppercase tracking-tight text-orange-500 mb-3">{title}</h2>
            <div className="space-y-2 text-zinc-300 leading-relaxed">{children}</div>
        </section>
    );
}
